<div class="select-account-template">
  <div *ngIf="loading$ | async" class="global-spinner-cnt">
    <mat-spinner color="primary" diameter="50"></mat-spinner>
  </div>
  <p class="select-account-question">{{'authorization_select_account_question' | translate}}</p>
  <div *ngFor="let tenant of tenants" class="tenant-container" (click)="save(tenant)">
    <p class="tenant-name">{{tenant.name}}</p>
  </div>
</div>
